import { AdminPageShell } from "@/components/admin/admin-page-shell";
import { LandingPlansEditor } from "@/components/admin/landing-plans-editor";

export function AdminLandingPlans() {
  return (
    <AdminPageShell
      title="Planes en la web"
      description="Los códigos FREE, PRO y ENTERPRISE deben coincidir con el backend. Lo publicado aparece en la landing y en el registro."
    >
      <LandingPlansEditor />
    </AdminPageShell>
  );
}
